import { RefreshCw } from "lucide-react";

// Shown when a page's data request failed for a transient reason (timeout,
// dropped connection, 5xx). Deliberately does NOT render <SEO noindex> and
// does NOT report a 404 — the page exists, the request just didn't land.
export const LoadError = ({ onRetry }) => (
  <div
    className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 text-center"
    data-testid="load-error"
  >
    <h1 className="font-display text-2xl font-black tracking-tight text-black">Couldn&apos;t load this page</h1>
    <p className="mt-3 text-sm text-zinc-600">
      The connection dropped on the way. The page is still here — give it another shot.
    </p>
    <button
      type="button"
      onClick={onRetry || (() => window.location.reload())}
      data-testid="load-error-retry"
      className="mt-8 border-2 border-black bg-black px-10 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:bg-white hover:text-black"
    >
      <RefreshCw size={13} className="mr-2 inline" /> Try again
    </button>
  </div>
);
